import baseConfig from '@actr/config';
import { useInject } from '@actr/di';
import { useNavigation } from '@actr/hooks';
import { Link } from '@actr/ui/src/components/link';
import type { HeaderManagerRef } from '@actr/widgets/src/components/_misc/layouts/header';
import { Header as DefaultHeader } from '@actr/widgets/src/components/_misc/layouts/header';
import { AkV2Routes } from '@actr/widgets/src/navigation/routes/ak-v2';
import useRedirectTo from 'Hooks/navigation/redirect-to';
import { reaction } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect, useRef } from 'react';
import ProjectUtils from 'Root/utils/project';
import LocalAuthStore from 'Store/auth';

import * as Styled from './style.css';

const Header = () => {
  const auth = useInject(LocalAuthStore);

  const { isRoute } = useNavigation();
  const { toHome: doRedirectToHome } = useRedirectTo();

  const headerManagerRef = useRef<HeaderManagerRef>({
    openLoginPopup: () => {}
  });
  const isAviaResultsPage = isRoute(AkV2Routes.AVIA_RESULTS) || isRoute(AkV2Routes.AVIA_SEARCH);

  const toHome = useCallback(() => {
    doRedirectToHome({ saveSearchParams: !isAviaResultsPage });
  }, [doRedirectToHome]);

  useEffect(() => {
    const disposer = reaction(() => auth.loginOpened, value => {
      if (value) {
        headerManagerRef.current?.openLoginPopup();

        auth.toggleOpenLoginForm(false);
      }
    });

    return () => disposer();
  }, []);

  if (ProjectUtils.isSber()) {
    return null;
  }

  if (ProjectUtils.isNordstar() && !auth.isAuthorized) {
    return (
      <div className={Styled.Header}>
        <Link href={AkV2Routes.HOME}>
          <img src={`${baseConfig.cmsMediaUrl}logo/nordstar.svg`} alt="" />
        </Link>
      </div>
    );
  }

  return (
    <DefaultHeader
      ref={headerManagerRef}
      redirectToHome={toHome}
      useLoginPopup={true}
    />
  );
};

export default observer(Header);
